import { render, staticRenderFns } from "./PriceCell.vue?vue&type=template&id=2a45059b&scoped=true&"
import script from "./PriceCell.vue?vue&type=script&lang=js&"
export * from "./PriceCell.vue?vue&type=script&lang=js&"
import style0 from "./PriceCell.vue?vue&type=style&index=0&id=2a45059b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45059b",
  null
  
)

export default component.exports